import React from "react";

function Skills({ skills }) {
  return (
    <section className="skills-section container px-0 my-5">
      <div className="row">
        <div className="col-xs-12 col-md-4 order-1">
          <h2>
            <span className="d-block">Skills</span>
            <span className="d-block">& Expertise</span>
          </h2>
        </div>
        <div className="col-xs-12 col-md-8 order-2">
          <ul className="skills-list">
            {skills.map((skill, index) => (
              <li key={index} className="skill-item mb-2">
                {skill}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Skills;
